import React from 'react';
import './Section.css';

function BiologySection() {
  const bioFeatures = [
    {
      title: 'Hypercarnivore Metabolic System',
      tag: 'Metabolism',
      desc: 'Cats are obligate carnivores requiring high levels of protein. Their liver lacks enzymes to down-regulate amino acid catabolism, and they cannot synthesize essential nutrients like taurine, arginine, and pre-formed vitamin A.'
    },
    {
      title: 'Vibrissae (Sensory Whiskers)',
      tag: 'Neurology',
      desc: 'Whiskers are deeply rooted tactile hairs (sinus hairs) loaded with nerve endings and proprioceptors. They detect minute air currents, spatial dimensions in low light, and convey subtle emotional states.'
    },
    {
      title: 'Flexible Spine & Righting Reflex',
      tag: 'Biomechanics',
      desc: 'With 30 vertebrae (excluding the tail) cushioned by elastic discs and a free-floating clavicle, felines possess exceptional rotational flexibility. Vestibular apparatus in the inner ear allows the righting reflex to orient their feet downward during falls.'
    },
    {
      title: 'Retractable Claws & Digitigrade Locomotion',
      tag: 'Anatomy',
      desc: 'Felines walk on their toes (digitigrade), maximizing stealth, stride length, and silent stalk. Elastic ligaments keep claws sheathed to maintain razor sharpness until tendon flexion exposes them for hunting or defense.'
    },
    {
      title: 'The Jacobson\'s (Vomeronasal) Organ',
      tag: 'Olfaction',
      desc: 'Located on the roof of the mouth, this chemical receptor detects pheromones through the Flehmen response (grimace-like expression), allowing them to assess territory, reproductive status, and social cues.'
    },
    {
      title: 'Auditory & Visual Specializations',
      tag: 'Sensory',
      desc: 'The tapetum lucidum amplifies dim light by up to 40%, and their 32 auricular muscles allow each ear to rotate 180 degrees independently to pinpoint high-frequency ultrasonic rodent rustles.'
    }
  ];

  return (
    <section className="section-panel">
      <div className="section-header">
        <h2>Feline Biology & Evolutionary Physiology</h2>
        <p>Understanding feline anatomy explains why cats react, communicate, and live the way they do.</p>
      </div>
      <div className="card-grid">
        {bioFeatures.map((feat, idx) => (
          <div key={idx} className="info-card">
            <span className="card-tag">{feat.tag}</span>
            <h3>{feat.title}</h3>
            <p>{feat.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default BiologySection;